'use strict';

var React = require('react');

var SvgBackspaceMajor = function SvgBackspaceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5v-11a1.5 1.5 0 0 0-1.5-1.5h-10.878a1.5 1.5 0 0 0-1.061.44l-6.122 5.5a1.5 1.5 0 0 0 0 2.121l6.122 5.5a1.5 1.5 0 0 0 1.06.439h10.88a1.5 1.5 0 0 0 1.5-1.5zm-3.292-9.307a1 1 0 0 1 0 1.414l-2.293 2.293 2.293 2.293a1 1 0 0 1-1.415 1.414l-2.292-2.293-2.293 2.293a1 1 0 1 1-1.415-1.414l2.293-2.293-2.293-2.293a1 1 0 1 1 1.415-1.414l2.292 2.293 2.292-2.293a1 1 0 0 1 1.415 0z"
  }));
};

exports.SvgBackspaceMajor = SvgBackspaceMajor;
